import { types } from 'mobx-state-tree';

import { ShippingSelectionFieldTypeType } from '../types/ShippingSelectionFieldType';
import ShippingSelectionFieldOption from './ShippingSelectionFieldOption';

const ShippingOptionSelectionField = types
  .model('ShippingOptionSelectionField', {
    id: types.identifierNumber,
    name: types.string,
    short_name: types.string,
    type: ShippingSelectionFieldTypeType,
    description: types.maybeNull(types.string),
    default_text: types.maybeNull(types.string),
    required: types.boolean,
    min_length: types.maybeNull(types.number),
    max_length: types.maybeNull(types.number),
    value: types.maybeNull(types.union(types.string, types.number, types.boolean)),
    options: types.optional(types.array(ShippingSelectionFieldOption), []),
  })
  .views((self) => ({
    findSelectionFieldOptionById(optionId) {
      return self.options.find((option) => option.id === optionId);
    },
  }));

export default ShippingOptionSelectionField;
